<template>
  <div class="login-wrap">
    <div class="main-block">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
        @keyup.enter.native="submitForm('ruleForm')"
      >
        <h1 class="title">
          <img src="static/title.png" alt="" />
        </h1>
        <h3 class="title">账号登录</h3>
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            auto-complete="off"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input
            style="width: 50%"
            type="text"
            v-model="ruleForm.captcha"
            auto-complete="off"
            placeholder="验证码"
          ></el-input>
          <img
            :src="'/sys/code/' + ruleForm.randomStr"
            alt="点击刷新"
            style="width: 45%; float: right"
            @click="randomFn"
          />
        </el-form-item>
        <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="width: 100%"
            @click="submitForm('ruleForm')"
            :loading="logining"
            >登录</el-button
          >
        </el-form-item>
        <div class="copyright-block" style="">
          Copyright © 2021北京爱才科技有限公司
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { login } from "../api/userMG";
import { getInfo } from "../api/userMG";
import { setCookie, getCookie, delCookie } from "../utils/util";
import md5 from "js-md5";
export default {
  name: "login",
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      img: "",
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
        captcha: "",
        randomStr: "1234",
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],

        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    this.randomFn();
    // 获取存在本地的用户名密码
    // this.getuserpwd()
  },
  // 里面的函数只有调用才会执行
  methods: {
    randomFn() {
      this.ruleForm.randomStr = Math.floor(Math.random() * 9000) + 1000;
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          // 测试通道，不为空直接登录
          // 注释
          login(this.ruleForm).then((res) => {
            console.log(res);
            if (res.msg == "success") {
              localStorage.setItem("logintoken", res.token);
              getInfo()
                .then((res) => {
                  if (res.msg == "success") {
                    localStorage.setItem("user_info", JSON.stringify(res.data));
                    //如果请求成功就让他2秒跳转路由
                    this.logining = false;
                    // 缓存token
                    if (res.data.roleId == 1) {
                      // admin
                    } else if (res.data.roleId == 2) {
                      this.$router
                        .push({ path: "/task/merchantList" })
                        .catch(() => {});
                    } else if (res.data.roleId == 3) {
                      this.$router
                        .push({ path: "/agent/index" })
                        .catch(() => {});
                    } else if (res.data.roleId == 4) {
                      this.$router
                        .push({ path: "/sales/index" })
                        .catch(() => {});
                    } else {
                      this.$router
                        .push({ path: "/index/work" })
                        .catch(() => {});
                    }
                  } else {
                    this.logining = false;
                    // 清除缓存
                    localStorage.removeItem("logintoken");
                    this.$message({
                      type: "error",
                      message: res.msg,
                    });
                  }
                })
                .catch((err) => {});
            } else {
              this.$message.error(res.msg);
              this.logining = false;
              return false;
            }
          });
        } else {
          // 获取图形验证码
          this.randomFn();
          this.logining = false;
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-wrap {
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: flex-end;
  background-image: url("../../src/assets/img/bg1.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  background-position: 50%;
  background-color: #d9e6ff;
  overflow: hidden;
}
.login-container {
  width: 350px;
  padding: 30px 35px 15px 35px;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  min-height: 450px;
  background: hsla(0, 0%, 100%, 0.7);
  border-radius: 8px;
  border: 1px solid #fff;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  margin-left: 20px;
}

.main-block {
  width: 1440px;
  height: 563px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 9%;
}

.img-center {
  position: absolute;
  width: 285px;
  bottom: 497px;
  right: 45px;
}
.img-center img {
  -webkit-transform: translateX(15px);
  transform: translateX(15px);
  position: absolute;
}
.img-center img:first-child {
  top: 50px;
  right: 232px;
  animation: imgCenterDown 8s linear infinite reverse;
}
.img-center img:nth-child(2) {
  top: 58px;
  right: 211px;
  animation: imgCenterDown 8s linear infinite;
}
.img-center img:nth-child(3) {
  top: 72px;
  right: 193px;
  animation: imgCenterDown 8s linear infinite reverse;
}
@keyframes imgCenterDown {
  25% {
    -webkit-transform: translate(15px, 6px);
    transform: translate(15px, 6px);
  }

  50%,
  100% {
    -webkit-transform: translate(15px);
    transform: translate(15px);
  }
  75% {
    -webkit-transform: translate(15px, -6px);
    transform: translate(15px, -6px);
  }
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.copyright-block {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #8c8c8c;
  line-height: 20px;
  text-align: center;
  margin-top: 24px;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue